<template>
  <v-dialog
    v-model="searchInvDialog"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    width="950"
    class="search-invoice"
  >
    <v-card class="pa-5">
      <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
        <v-card-text class="pa-0 text-body-1">
        {{ $t('searchInvoice') }} ({{ $t(type) }})
        </v-card-text>
        <v-icon
          size="15"
          @click="searchInvDialog = false"
        >
        mdi-close
        </v-icon>
      </v-container>
      <v-container class="pa-0 mt-5 ma-0 d-flex gap-3">
        <div style="width: 25%;height: 400px;">
          <div 
            class="d-flex flex-column justify-space-between"
            style="height: 100%;"
          >
            <!--simple filter-->
            <div 
              v-if="toggleFilter == 'advance_filter'"
              class="d-flex flex-column gap-5"
            >
              <v-text-field
                  v-model="number"
                  height="20"
                  dense
                  outlined
                  class="dense"
                  clearable
                  :label="$t('invoic-number')"
                  ref="number"
              />
              <v-text-field
                v-model="mobile"
                :label="$t('mobile')"
                outlined
                clearable
                dense
              />
              <autocomplete
                  v-model="account"
                  :title="$t('customer')"
                  type="person"
                  :value="account"
              />
              <autocomplete
                v-model="product"
                type="productService"
                :value="product"
                :title="$t('product/service')"
              />
              <money
                  v-model="amount"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  class="dense"
              /> 
              <template>
                <v-text-field
                    id="date"
                    v-model="invDate"
                    :label="$t('date')"
                    outlined
                    hide-details
                    dense
                    clearable
                    ref="date"
                />
                <date-picker
                    v-model="invDate"
                    element="date"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                />
              </template>
            </div>
            <!--advance filter-->
            <div 
              v-if="toggleFilter == 'simple_filter'"
              class="d-flex flex-column gap-5"
            >
              <div>
                <v-card-text class="pa-0 text-body-2">{{ $t('invoic-number') }}</v-card-text>
                <div class="d-flex align-center gap-2 mt-1">
                  <v-text-field
                    v-model="fromNum"
                    height="20"
                    dense
                    outlined
                    class="dense"
                    clearable
                    :label="$t('from-number')"
                    ref="number"
                  />
                  <v-text-field
                    v-model="toNum"
                    height="20"
                    dense
                    outlined
                    class="dense"
                    clearable
                    :label="$t('toNumber')"
                    ref="number"
                  />
                </div>
              </div>
              <div class="mt-2">
                <v-card-text class="pa-0 text-body-2">{{ $t('date') }}</v-card-text>
                <div class="d-flex align-center mt-1">
                  <template>
                    <v-text-field
                        id="fromDate"
                        v-model="fromDate"
                        :label="$t('fromDate')"
                        outlined
                        hide-details
                        dense
                        clearable
                        ref="date"
                        class="ml-2"
                    />
                    <date-picker
                        v-model="fromDate"
                        element="fromDate"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                        @close="setDate"
                    />
                  </template>
                  <template>
                    <v-text-field
                        id="toDate"
                        v-model="toDate"
                        :label="$t('toDate')"
                        outlined
                        hide-details
                        dense
                        clearable
                        ref="date"
                    />
                    <date-picker
                        v-model="toDate"
                        element="toDate"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                        @close="setDate"
                    />
                  </template>
                </div>
              </div>
              <div class="mt-2">
                <v-card-text class="pa-0 text-body-2">{{ $t('amount') }}</v-card-text>
                <div class="d-flex align-center flex-column gap-2 mt-3">
                  <money
                    v-model="fromAmount"
                    :label="$t('fromAmount')"
                    :dense="true"
                    :outlined="true"
                    :solo="false"
                    :clearable="true"
                    value-when-is-empty="0"
                    :options="options"
                    class="dense w-100"
                  />
                  <money
                    v-model="toAmount"
                    :label="$t('toAmount')"
                    :dense="true"
                    :outlined="true"
                    :solo="false"
                    :clearable="true"
                    value-when-is-empty="0"
                    :options="options"
                    class="dense mt-5 w-100"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex align-center gap-2">
              <v-btn
                color="primary"
                class="flex-fill w-100"
                height="32"
                @click="fetchInvoiceList"
              >
                {{ $t('apply-filter') }}
              </v-btn>
              <v-btn
                color="primary"
                outlined
                class="flex-fill w-100"
                height="32"
                @click="toggle"
              >
                {{ $t(toggleFilter) }}
              </v-btn>
            </div>
          </div>
        </div>
        <div 
          class="ag-theme-alpine custom-grid-theme flex-fill" 
          style="height: 400px;"
        >
          <AgGridVue
            class="ag-theme-alpine invoice-list"
            style="width: 100%;height: 100%;"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :defaultColDef="defaultColDef"
            :gridOptions="gridOptions"
            rowSelection="single" 
            suppressRowClickSelection="false"
            @grid-ready="onGridReady"
            @rowClicked="onRowClicked"
            @cell-key-down="onCellKeyDown"
            rowModelType="infinite"
            :cacheBlockSize="10" 
            :singleClickEdit="false"
            :stopEditingWhenCellsLoseFocus="true"
            :overlayLoadingTemplate="`<span class='ag-overlay-loading-center'>${$t('fetching-data')}</span>`"
            :overlayNoRowsTemplate="`<span class='ag-overlay-loading-center'>${$t('no-data-found')}</span>`"
          />
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { AgGridVue } from 'ag-grid-vue'
import General from '@/Mixins/general.js'

export default {
  props: {
    isDialogVisible: Boolean,
    invoiceType: String
  },
  data () {
    return {
      searchInvDialog: false,
      rowData: [],
      columnDefs: null,
      defaultColDef: {
        flex: 1,
        resizable: true
      },
      gridOptions: {
        enableRtl: true,
        context: { componentParent: this },
        rowDragManaged: true
      },
      gridApi: null,
      optionsApi: {
        page: 1,
        itemsPerPage: 10
      },
      type: null,
      number: null,
      invDate: null,
      mobile: null,
      account: null,
      product: null,
      amount: null,
      toggleFilter: null,
      fromNum: null,
      toNum: null,
      fromDate: null,
      toDate: null,
      fromAmount: null,
      toAmount: null
    }
  },
  mixins: [General],
  components: {
    AgGridVue
  },
  mounted() {
    document.addEventListener('keydown', this.globalKeyDown)
    this.toggleFilter = 'advance_filter'
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.globalKeyDown)
  },
  methods: {
    globalKeyDown (event) {
      if (!this.searchInvDialog) return
      const api = this.gridApi
      if (!api) return
      const key = event.key

      if (key === 'PageDown' || event.code === 'PageDown' || key === 'ArrowDown') {
        event.preventDefault()
        this.navigateRow(api, 1)
      }
      if (key === 'PageUp' || event.code === 'PageUp' || key === 'ArrowUp') {
        event.preventDefault()
        this.navigateRow(api, -1)
      }
      if (key === 'Enter') {
        const selectedNodes = api.getSelectedNodes()
        if (selectedNodes.length) {
          this.sendInvoice(selectedNodes[0].data)
        }
      }
    },
    navigateRow(api, direction) {
      const selectedNodes = api.getSelectedNodes()

      // if nothing is selected yet, select first row on PageDown
      if (!selectedNodes.length) {
        if (direction === 1) {
          api.getDisplayedRowAtIndex(0)?.setSelected(true)
        } else {
          // PageUp first press → last row
          const lastIndex = api.getDisplayedRowCount() - 1
          api.getDisplayedRowAtIndex(lastIndex)?.setSelected(true)
        }
        return
      }

      // if already selected → move relative
      const currentIndex = selectedNodes[0].rowIndex
      const nextIndex = currentIndex + direction

      if (nextIndex >= 0 && nextIndex < api.getDisplayedRowCount()) {
        api.getDisplayedRowAtIndex(nextIndex).setSelected(true)
        api.ensureIndexVisible(nextIndex) // scrolls into view
      }
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.setDataSource()
    },
    setDataSource() {
      const dataSource = {
        getRows: async (params) => {
          const pageSize = this.optionsApi.itemsPerPage
          const page = Math.floor(params.startRow / pageSize) + 1
          this.gridApi.showLoadingOverlay()
          try {
            const res = await this.$axios.get(this.$endpoint + 'invoice', {
              params: {
                page,
                options: { itemsPerPage: pageSize },
                type: this.type,
                number: this.toggleFilter == 'advance_filter' ? this.number : null,
                mobile: this.toggleFilter == 'advance_filter' ? this.mobile : null,
                accountProp: this.toggleFilter == 'advance_filter' ? this.account?.id : null,
                product: this.toggleFilter == 'advance_filter' ? this.product?.id : null,
                amount: this.toggleFilter == 'advance_filter' ? this.amount : null,
                date: this.toggleFilter == 'advance_filter' ? this.invDate : null,
                fromNum: this.toggleFilter == 'simple_filter' ? this.fromNum : null,
                toNum: this.toggleFilter == 'simple_filter' ? this.toNum : null,
                fromDate: this.toggleFilter == 'simple_filter' ? this.fromDate : null,
                toDate: this.toggleFilter == 'simple_filter' ? this.toDate : null,
                fromAmount: this.toggleFilter == 'simple_filter' ? this.fromAmount : null,
                toAmount: this.toggleFilter == 'simple_filter' ? this.toAmount : null
              }
            })
            // const rows = res.data.data
            // const totalRows = res.data.total || (res.data.last_page * pageSize)
            // params.successCallback(rows, totalRows)
            // this.gridApi.hideOverlay()

            const rows = res.data.data || []
            const totalRows = res.data.total ?? rows.length

            if (!rows.length) {
              params.successCallback([], 0)
              this.gridApi.showNoRowsOverlay()
            } else {
              params.successCallback(rows, totalRows)
              this.gridApi.hideOverlay()
            }

          } catch (err) {
            params.failCallback()
            this.serverErrorHandeler(err)
            this.gridApi.showNoRowsOverlay()
          }
        }
      }
      this.gridApi.setDatasource(dataSource)
    },
    fetchInvoiceList() {
      if (this.gridApi) {
        // this.gridApi.purgeInfiniteCache()  
        this.setDataSource()             
      }
    },
    onRowClicked (params) {
      this.sendInvoice(params.data)
    }, 
    onCellKeyDown(event) {
      if (event.event.key === 'Enter') {
        const rowNode = event.node
        if (rowNode) {
          event.api.deselectAll()
          rowNode.setSelected(true)
          this.sendInvoice(rowNode.data)
        }
      }
    },
    sendInvoice (value) {
      this.$emit('onSelectedRow', value)
    },
    toggle () {
      if (this.toggleFilter == 'simple_filter') {
        this.fromNum = null
        this.toNum = null
        this.fromDate = null
        this.toDate = null
        this.fromAmount = null
        this.toAmount = null
        this.toggleFilter = 'advance_filter'
      } else {
        this.number = null
        this.mobile = null
        this.account = null
        this.product = null
        this.amount = null
        this.invDate = null
        this.toggleFilter = 'simple_filter'
      }
    }
  },
  watch: {
    isDialogVisible (val) {
      if (val) {
        this.searchInvDialog = true
      } else {
        this.searchInvDialog = false
      }
    },
    searchInvDialog (val) {
      if (!val) {
        if (this.gridApi) {
          this.gridApi.deselectAll()
        }
        this.$emit('searchInvClosed')
      }
    },
    invoiceType (val) {
      if (val == 'sell') {
        this.type = 'sell'
      }
      if (val == 'returnSell') {
        this.type = 'returnSell'
      }
      if (val == 'purchase') {
        this.type = 'purchase'
      }
      if (val == 'returnPurchase') {
        this.type = 'returnPurchase'
      }
      if (val == 'presale') {
        this.type = 'presale'
      }
      this.fetchInvoiceList()
    }
  },
  beforeMount () {
    this.columnDefs = [
      {
        headerName: this.$t('invoic-number'),
        field: 'number',
        pinned: 'right',
        width: 70,
        minWidth: 70,
        maxWidth: 70,
        resizable: false
      },
      {
        headerName: this.$t('invoice-id'),
        cellRenderer: params => {
            const id = params.data?.id
            const uid = params.data?.uid
            return `
            <div class="d-flex flex-column">
                <v-card-text class="pa-0 text-body-2">#${id}</v-card-text>
                <v-card-text class="pa-0 text-body-2" style="font-size: 8pt !important;color: gray;">${uid}</v-card-text>
            </div>
            `
        }
      },
      {
        headerName: this.$t('detailsInvoice'),
        cellRenderer: params => {
            const name = params.data?.customer?.name || params.context.componentParent.$t('haveNot')
            const mobile = params.data?.customer?.mobile || params.context.componentParent.$t('haveNot')
            return `
            <div class="d-flex flex-column">
                <v-card-text class="pa-0 text-body-2">${name}</v-card-text>
                <v-card-text class="pa-0 text-body-2" style="font-size: 8pt !important;color: gray;direction: ltr;">${mobile}</v-card-text>
            </div>
            `
        }
      },
      {
        headerName: this.$t('amount'),
        cellRenderer: params => {
            const price = params.data?.price?.price || 0
            const formatted = params.context.componentParent.$numberFormat(price)
            const currency = params.data?.currency?.symbol || ''
            return `
            <div>
                <v-card-text class="pa-0 text-body-2">${formatted}</v-card-text>
                <v-card-text class="pa-0 text-body-2" style="font-size: 8pt !important;color: gray;direction: ltr;">${currency}</v-card-text>
            </div>
            `
        }
      },
      {
        headerName: this.$t('register-date'),
        field: 'date'
      },
      {
        headerName: this.$t('action'),
        cellRenderer: params => {
          return `
          <v-btn 
            color="primary"
            data-id="${params.data?.id}"
          >
          ${params.context.componentParent.$t('select')}
          </v-btn>
          `
        },
        onCellClicked: params => {
          params.context.componentParent.sendInvoice(params.data)
        },
        width: 75,
        minWidth: 75,
        maxWidth: 75,
        resizable: false
      }
    ]
  }
}
</script>
<style>
.ag-theme-alpine.invoice-list .ag-row {
  cursor: pointer;
}
.ag-theme-alpine.invoice-list .ag-row.ag-row-focus {
  background-color: rgba(33, 150, 243, 0.3) !important;
}
.ag-theme-alpine.invoice-list .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  border-color: transparent !important;
}
.ag-cell-value.ag-cell {
  font-size: 9pt;
}
.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
    font-size: 8.5pt;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-left: none;
}
.ag-pinned-right-header .ag-header-cell-label,
.ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {
    justify-content: center;
}
.ag-header-cell.ag-column-first.ag-header-cell-sortable.ag-focus-managed {
    padding: 0;
}
.center-cell {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ag-input-field-input.ag-checkbox-input{
  cursor: pointer;
}
.ag-theme-alpine .ag-header-cell, .ag-theme-alpine .ag-header-group-cell {
  padding: 10px;
}
.ag-theme-alpine .ag-rtl .ag-selection-checkbox {
  margin-left: 0;
}
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(2) {
  display: none;
}
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(1),
.ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell.ag-focus-managed:nth-child(3) {
  overflow: visible;
}
.ag-theme-alpine .ag-rtl .ag-has-focus .ag-pinned-right-cols-container .ag-cell-focus.ag-cell-focus:not(.ag-cell-range-selected) {
  border: 1px solid transparent;
}
.ag-theme-alpine .ag-header-cell-resize::after {
  display: none;
}
.ag-theme-alpine .ag-pinned-right-header {
  border-left: none;
}
.ag-theme-alpine .ag-pinned-right-cols-container .ag-row .ag-cell {
  border-right: none;
}
.ag-theme-alpine .ag-pinned-right-header .ag-header-row.ag-header-row-column .ag-header-cell:nth-child(1) {
  border-right: none;
}
.ag-theme-alpine .ag-row {
  border-bottom: 1px solid #d3d3d3;
}
.ag-theme-alpine .ag-cell {
  border-right: 1px solid #d3d3d3;
}
.ag-theme-alpine .ag-header-cell {
  border-right: 1px solid #b0b0b0;
}
.ag-row-odd  {
  background-color: #c0c0c033 !important;
}
.ag-header {
  background-color: #c0c0c0bd !important;
}
.ag-cell-label-container {
  padding: 0;
}
.ag-header-cell,
.ag-header-row.ag-header-row-column {
  height: 35px !important;
}
.ag-header {
  height: 35px !important;
  min-height: 35px !important;
}
.ag-header-cell-text {
  font-size: 9pt;
}
.ag-body-horizontal-scroll,
.ag-body-vertical-scroll {
  display: none !important;
}
</style>